// Import Swiper and modules
// Reference: https://swiperjs.com/swiper-api
import SwiperCore, { Navigation, A11y } from 'swiper/core';

const Swiper = SwiperCore.use([Navigation, A11y]);

export function trendingSwiper() {
  const swiperContainer = document.querySelector('.swiper-container.trending__carousel');
  if (typeof swiperContainer !== 'undefined' && swiperContainer !== null) {
    const swiper = new Swiper('.trending__carousel', {
      slidesPerView: 2,
      spaceBetween: 30,
      centeredSlides: true,
      navigation: {
        nextEl: '.trending__carousel .swiper-button-next',
        prevEl: '.trending__carousel .swiper-button-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 3,
          centeredSlides: false,
        },
        1400: {
          slidesPerView: 4,
          centeredSlides: false,
        },
      },
      loop: true,
    });

    // Fixes bug where number of slides on load is incorrect
    document.addEventListener('DOMContentLoaded', () => swiper.update());
  }
}

export function heroSwiper() {
  const swiperContainers = document.querySelectorAll('.swiper-container.hero__carousel');
  if (typeof swiperContainers !== 'undefined' && swiperContainers !== null) {
    const swipers = [];
    swiperContainers.forEach((swiperContainer) => {
      if (swiperContainer.classList.contains('post-module--hero-variation_5')) {
        // Full Width simple carousel
        const swiper = new Swiper('.hero__carousel--variation_5', {
          slidesPerView: 2,
          spaceBetween: 30,
          centeredSlides: true,
          preventInteractionOnTransition: true,
          navigation: {
            nextEl: '.hero__carousel .swiper-button-next',
            prevEl: '.hero__carousel .swiper-button-prev',
          },
          breakpoints: {
            640: {
              slidesPerView: 3,
            },
            992: {
              slidesPerView: 4,
            },
          },
          loop: true,
        });
        swipers.push(swiper);
      }

      if (swiperContainer.classList.contains('post-module--hero-variation_6')) {
        // Full Width offset nav controls Featured carousel
        const swiper = new Swiper('.hero__carousel--variation_6', {
          slidesPerView: 1,
          spaceBetween: 30,
          centeredSlides: false,
          navigation: {
            nextEl: '.hero__carousel .swiper-button-next',
            prevEl: '.hero__carousel .swiper-button-prev',
          },
          breakpoints: {
            576: {
              slidesPerView: 2,
            },
          },
          loop: true,
        });
        swipers.push(swiper);
      }
    });
    // Fixes bug where number of slides on load is incorrect
    document.addEventListener('DOMContentLoaded', () => swipers.forEach((swiper) => swiper.update()));
  }
}

export function carouselModuleSwiper() {
  const swiperContainers = document.querySelectorAll('.swiper-container.carousel__container');
  if (typeof swiperContainers !== 'undefined' && swiperContainers !== null) {
    const swipers = [];
    swiperContainers.forEach((carouselDetails) => {
      const target = `.carousel__container[data-position="${carouselDetails.dataset.position}"]`;
      const nextElTarget = `${target} ~ .swiper-button-next--carousel`;
      const prevElTarget = `${target} ~ .swiper-button-prev--carousel`;
      const swiper = new Swiper(target, {
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: true,
        navigation: {
          nextEl: nextElTarget,
          prevEl: prevElTarget,
        },
        breakpoints: {
          576: {
            slidesPerView: 2,
          },
          640: {
            slidesPerView: 3,
          },
        },
        loop: true,
      });
      setTimeout(() => { swiper.update(); }, 200);
      swipers.push(swiper);
    });

    // Fixes bug where number of slides on load is incorrect
    document.addEventListener('DOMContentLoaded', () => swipers.forEach((swiper) => swiper.update()));
  }
}
